import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import { history } from 'helpers/history';

import Button from 'components/commons/Button';

import { ButtonsContainer } from './styles';

import './i18n';

const ProceduresButtons: FunctionComponent = () => (
  <ButtonsContainer>
    <Button onClick={() => history.push('/public/procedures/forms/divorces/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:DIVORCE')}
    </Button>
    <Button onClick={() => history.push('/public/procedures/forms/jewishness/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:JEWISHNESS')}
    </Button>
    <Button onClick={() => history.push('/public/procedures/forms/deaths/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:DEATH')}
    </Button>
    <Button onClick={() => history.push('/public/procedures/forms/reservations/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:RESERVATION')}
    </Button>
    <Button onClick={() => history.push('/public/procedures/forms/marriages/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:MARRIAGE')}
    </Button>
    <Button onClick={() => history.push('/public/procedures/forms/matzeva/create')}>
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:MATZEVA')}
    </Button>
  </ButtonsContainer>
);

export default ProceduresButtons;
